import { defineStore } from 'pinia';

import { RouterLinkProps } from 'vue-router';

export interface HeaderState {
   breadcrumbs: Array<HeaderLink>;
   tabs: Array<HeaderLink>;
}

export interface HeaderLink extends RouterLinkProps {
   content: string;
}

export const useAppStore = defineStore('app', () => {
   const isDev = computed(() => ['dev', 'test'].includes(import.meta.env.VITE_APP_ENV));

   //#region Breadcrumbs
   const breadcrumbs = ref<Array<HeaderLink>>([{ to: '/', content: 'NxtJob' }]);
   const tabs = ref<Array<HeaderLink>>([]);

   function setBreadcrumbs(breadcrumbsToAdd: Array<HeaderLink>) {
      breadcrumbs.value = [{ to: '/', content: 'NxtJob' }, ...breadcrumbsToAdd];
   }

   function setTabs(newTabs: Array<HeaderLink>) {
      tabs.value = newTabs;
   }
   //#endregion

   return {
      isDev,
      breadcrumbs,
      tabs,
      setBreadcrumbs,
      setTabs,
   };
});
